// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2feOT","search":"Settings_search__3hq3y","filter":"Settings_filter__3-esi"};